// Pure helpers for the Evidence page: plain "why is this here" lines, expiry bars, filters and the about-to-be-deleted box.
import { whatLabel } from './jobsLogic';

export const KINDS = [
  { id: 'all', label: 'All' }, { id: 'report', label: 'Reports', color: '#4ade80' }, { id: 'log', label: 'Logs', color: '#93c5fd' },
  { id: 'input', label: 'Inputs', color: '#fcd34d' }, { id: 'export', label: 'Exports', color: '#c4b5fd' }, { id: 'other', label: 'Other', color: '#94a3b8' }
];
export const kindOf = (a) => KINDS.find((k) => k.id === a.category) || KINDS[5];
export const purged = (a) => Boolean(a.meta?.purged_at);

export function whyLine(a) {
  const scan = `${whatLabel(a.scan_type)} on ${a.target_value || 'an address'}`;
  const tool = a.source_tool ? a.source_tool[0].toUpperCase() + a.source_tool.slice(1) : 'the scan tool';
  if (a.category === 'log') return `Log from ${tool} during ${scan}`;
  if (a.category === 'input') return `What ${scan} was given to work on`;
  if (a.category === 'export') return `Export made from ${scan}`;
  if (a.category === 'report') return `${a.source_tool ? `Output of ${tool}` : 'Report'} from ${scan}`;
  return `File from ${scan}`;
}

export function size(bytes) {
  const n = Number(bytes) || 0;
  if (!n) return '-';
  if (n < 1024) return `${n} B`;
  if (n < 1048576) return `${Math.round(n / 1024)} KB`;
  return `${(n / 1048576).toFixed(n < 10485760 ? 1 : 0)} MB`;
}

// How long is left: words for people and a 0-100 bar.
export function expiry(a, now = new Date()) {
  if (purged(a)) return { text: 'Deleted', pct: 0, days: null };
  if (!a.retention_until) return { text: 'Kept', pct: 100, days: null };
  const msLeft = new Date(a.retention_until) - now;
  const total = Math.max(1, new Date(a.retention_until) - new Date(a.created_at || now));
  const days = Math.ceil(msLeft / 86400000);
  return { text: msLeft <= 0 ? 'Deleted soon' : days === 1 ? 'Deleted tomorrow' : `Deleted in ${days} days`, pct: Math.max(0, Math.min(100, Math.round((msLeft / total) * 100))), days };
}

export const aboutToGo = (list, now = new Date(), withinDays = 7, max = 5) =>
  list.filter((a) => !purged(a) && a.retention_until && new Date(a.retention_until) - now <= withinDays * 86400000)
    .sort((a, b) => new Date(a.retention_until) - new Date(b.retention_until)).slice(0, max);

export function filterArtifacts(list, { kind, q, showDeleted }) {
  const s = q.trim().toLowerCase();
  return list.filter((a) => (showDeleted || !purged(a)) && (kind === 'all' || a.category === kind)
    && (!s || `${a.label} ${a.target_value} ${a.source_tool} ${whatLabel(a.scan_type)}`.toLowerCase().includes(s)));
}
export const kindCount = (list, kind, showDeleted) => list.filter((a) => (showDeleted || !purged(a)) && (kind === 'all' || a.category === kind)).length;
export const newestFirst = (list) => [...list].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
